import { isArray, isObject } from "lodash";

export const deleteObjectKeysByPath = (source, paths = []) => {
  if (!isObject(source)) return source;

  // Convert "borrowers[0].firstName" -> ["borrowers", "0", "firstName"]
  const parsePath = (path) =>
    path
      .replace(/\[(\d+)\]/g, ".$1")
      .split(".")
      .filter(Boolean);

  const deleteAtPath = (obj, pathParts, index = 0) => {
    if (!isObject(obj)) return obj;

    const key = pathParts[index];
    const isLast = index === pathParts.length - 1;

    if (isArray(obj)) {
      const arr = [...obj];
      const idx = Number(key);

      if (Number.isNaN(idx) || idx < 0 || idx >= arr.length) return obj;

      if (isLast) {
        // Delete array index
        arr.splice(idx, 1);
        return arr;
      }

      arr[idx] = deleteAtPath(arr[idx], pathParts, index + 1);
      return arr;
    }

    // Plain object
    if (!Object.prototype.hasOwnProperty.call(obj, key)) {
      return obj;
    }

    if (isLast) {
      const { [key]: _, ...rest } = obj;
      return rest;
    }

    return {
      ...obj,
      [key]: deleteAtPath(obj[key], pathParts, index + 1),
    };
  };

  return paths.reduce((acc, path) => {
    const parts = parsePath(path);
    return deleteAtPath(acc, parts);
  }, source);
};
